export default "__VITE_ASSET__CCjtQ8vb__"